import module from 'kendu/legacy/module'
import './style.scss'

module.directive('deprecatedLoadbar', ($compile, $rootScope) => ({
  link (scope, element) {
    let parent = element.parent()
    let comment = $compile.$$createComment('deprecatedLoadbar')

    element.replaceWith(comment)
    element.addClass('kd-animate')

    $rootScope.$on('KdLoadIndicator:start', StartIndicator)
    $rootScope.$on('KdLoadIndicator:complete', StopIndicator)

    function StartIndicator () {
      parent.prepend(element)
    }

    function StopIndicator () {
      element.remove()
    }
  },
}))



// WEBPACK FOOTER //
// ./src/deprecated/directive/deprecated-loadbar/component.js